module.exports = __webpack_public_path__ + "assets/img/delivery1.7910b63f.png";